import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log('RequireAuth check:', {
    user,
    loading,
    path: location.pathname
  });

  if (loading) {
    return <CircularProgress />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Allow access to credits page for individual users and team admins
  if (location.pathname === '/credits') {
    const canAccessCredits = user.role === 'individual' || 
                           ['admin', 'corporate', 'school_admin'].includes(user.role);
    if (!canAccessCredits) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default RequireAuth; 